
<p-dialog header="Leave Feedback" [(visible)]="display" [style]="{ width: '35rem' }" [modal]="true">
    <div class="flex align-items-center gap-3 mb-2">
        <label for="email"style="margin-right: 10px;">Email</label><br>
        <input pInputText id="email" class="flex-auto" autocomplete="on" />
    </div>
    <div class="flex align-items-center gap-3 mb-2">
        <label for="Comment"style="margin-right: 10px;">Comment</label><br>
        <textarea pInputTextarea [(ngModel)]="feedbackText" rows="5" cols="30"></textarea>
    </div>   
    <div class="flex justify-content-end gap-2">
        <p-button label="Submit" class="btn-primary" severity="secondary"  />
    </div>
</p-dialog>
